document.addEventListener("DOMContentLoaded", function () {
  const copy = document.querySelector(".logos-slide").cloneNode(true);
  const copy2 = document.querySelector(".logos-slide").cloneNode(true);
  document.querySelector(".references-items").appendChild(copy);
  document.querySelector(".references-items").appendChild(copy2);
});
